import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { ClientUserRef } from 'dy-frontend-http-repository/lib/modules/ClientUser/refs';
import { ClientUserTeamConnectionsResource } from 'dy-frontend-http-repository/lib/modules/ClientUser/resources';
import repository from 'dy-frontend-http-repository/lib/repository';

import domain from './domain';

// Fetch team connections
export const fetchTeamConnections = domain.createEffect<
    { id: ID },
    CollectionResource<ClientUserTeamConnectionsResource, {}>
>({
    name: 'fetchTeamConnections',
    handler: async ({ id }) => {
        return await repository.clientUser().getTeamConnections(id);
    },
});

// Attach team to a client user
export const connectTeam = domain.createEffect<{ id: ID; teamId: ID }, ClientUserRef>({
    name: 'connectTeam',
    handler: async ({ id, teamId }) => {
        return await repository.clientUser().connectTeam(id, teamId);
    },
});

// Delete client user team attachment
export const removeTeamConnection = domain.createEffect<{ userId: ID; teamId: ID }, ClientUserRef>({
    name: 'removeTeamConnection',
    handler: async ({ userId, teamId }) => {
        return await repository.clientUser().removeTeamConnection(userId, teamId);
    },
});
